<template>
  <v-row
    v-bind:style="{
      backgroundColor: '#FFFCF4'
    }"
  >
    <v-col cols="12" class="pa-0">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="auto">
      <v-icon size="20" color="noteprimary">message</v-icon>
    </v-col>
    <v-col class="lighttext--text caption my-auto">
      {{ note.createdDate | longDateWithTime }}
    </v-col>
    <v-col cols="auto" class="px-0">
      <user-avatar :size="20" :user="note.createdBy"></user-avatar>
    </v-col>
    <v-col cols="auto" class="pa-1">
      <v-menu absolute>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            :disabled="!note.canSave || disabled"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('edit', note)">
            <v-list-item-icon>
              <v-icon>edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteNote()">
            <v-list-item-icon>
              <v-icon>delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col
      cols="12"
      class="secondarytext--text font-weight-light subtitle-2 pt-0"
    >
      {{ note.text }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "NoteLineItem",
  props: {
    note: { type: Object },
    deleteAction: { type: String },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    async deleteNote() {
      if (
        await this.$root.$confirm(
          "Delete note",
          "Are you sure you want to delete this note?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch(this.deleteAction, this.note)
          .then(data => {
            this.$emit("delete", data);
            this.$root.$snackbarSuccess("Note deleted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a note."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__content {
  flex-basis: 100%;
}
</style>
